export default __webpack_public_path__ + "static/media/Shoulder_Pain.6b2eb0de.jpg";